(function() {
  const RESTRICTED_ZONES = {"type":"FeatureCollection","name":"Capa sin titulo","features":[{"type":"Feature","properties":{"Name":"Limonada"},"geometry":{"type":"Polygon","coordinates":[[[-90.5048809,14.6272211],[-90.4990015,14.6264736],[-90.4979072,14.6309997],[-90.5011687,14.6321001],[-90.5029497,14.6313319],[-90.5041299,14.6314565],[-90.5048809,14.6272211]]]}},{"type":"Feature","properties":{"Name":"Gallito"},"geometry":{"type":"Polygon","coordinates":[[[-90.5298731,14.6371393],[-90.5283174,14.6330804],[-90.5263541,14.6328832],[-90.5232534,14.6373884],[-90.5230614,14.6386821],[-90.526044,14.6390973],[-90.5263015,14.6388274],[-90.5284043,14.6391804],[-90.5296596,14.6397409],[-90.530239,14.6391389],[-90.5298731,14.6371393]]]}},{"type":"Feature","properties":{"Name":"Arimany"},"geometry":{"type":"Polygon","coordinates":[[[-90.4923222,14.6964866],[-90.4913727,14.6954903],[-90.4901335,14.6963361],[-90.4912171,14.6972909],[-90.4923222,14.6964866]]]}},{"type":"Feature","properties":{"Name":"Santa Faz"},"geometry":{"type":"Polygon","coordinates":[[[-90.4912004,14.6948961],[-90.4898164,14.6902156],[-90.4857073,14.6918865],[-90.4870055,14.697117],[-90.4901335,14.6963361],[-90.4912004,14.6948961]]]}},{"type":"Feature","properties":{"Name":"Rosario"},"geometry":{"type":"Polygon","coordinates":[[[-90.4727811,14.6869601],[-90.4610652,14.6734679],[-90.4531688,14.6798612],[-90.4565591,14.69327],[-90.4727811,14.6869601]]]}},{"type":"Feature","properties":{"Name":"limon"},"geometry":{"type":"Polygon","coordinates":[[[-90.4771229,14.6694642],[-90.4721018,14.6596246],[-90.4634329,14.6622817],[-90.4667374,14.6732421],[-90.4771229,14.6694642]]]}},{"type":"Feature","properties":{"Name":"el arco"},"geometry":{"type":"Polygon","coordinates":[[[-90.4596063,14.6632128],[-90.4418393,14.6495946],[-90.4239865,14.6593101],[-90.4270764,14.6692328],[-90.4596063,14.6632128]]]}}]};

  function pointInPolygon(point, polygon) {
    const x = point.lng, y = point.lat;
    let inside = false;
    const coords = polygon[0];
    for (let i = 0, j = coords.length - 1; i < coords.length; j = i++) {
      const xi = coords[i][0], yi = coords[i][1];
      const xj = coords[j][0], yj = coords[j][1];
      const intersect = ((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
      if (intersect) inside = !inside;
    }
    return inside;
  }

  function isRestricted(lat, lng) {
    const point = { lat, lng };
    return RESTRICTED_ZONES.features.some(feature =>
      pointInPolygon(point, feature.geometry.coordinates)
    );
  }

  function showResult(restricted) {
    const result = document.getElementById('delivery-result');
    result.style.display = 'block';
    if (restricted) {
      result.className = 'delivery-checker__result delivery-checker__result--error';
      result.innerHTML = '❌ Lamentablemente no cubrimos tu zona para envío.';
    } else {
      result.className = 'delivery-checker__result delivery-checker__result--success';
      result.innerHTML = '✅ Podemos realizar tu pedido.';
    }
  }

  function initDeliveryChecker() {
    const input = document.getElementById('delivery-address-input');
    const btn = document.getElementById('delivery-check-btn');
    const select = document.getElementById('saved-address-select');

    if (!input) return;

    const autocomplete = new google.maps.places.Autocomplete(input, {
      componentRestrictions: { country: 'gt' },
      fields: ['geometry']
    });

    btn.addEventListener('click', function() {
      const place = autocomplete.getPlace();
      if (place && place.geometry) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        showResult(isRestricted(lat, lng));
      } else {
        // Geocode manual input
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address: input.value + ', Guatemala' }, function(results, status) {
          if (status === 'OK') {
            const lat = results[0].geometry.location.lat();
            const lng = results[0].geometry.location.lng();
            showResult(isRestricted(lat, lng));
          }
        });
      }
    });

    // Saved addresses
    if (select) {
      select.addEventListener('change', function() {
        if (this.value) {
          input.value = this.value;
          const geocoder = new google.maps.Geocoder();
          geocoder.geocode({ address: this.value + ', Guatemala' }, function(results, status) {
            if (status === 'OK') {
              const lat = results[0].geometry.location.lat();
              const lng = results[0].geometry.location.lng();
              showResult(isRestricted(lat, lng));
            }
          });
        }
      });
    }
  }

  window.initDeliveryChecker = initDeliveryChecker;
})();
